export default __webpack_public_path__ + "static/media/E1.de3d6de5.jpg";